import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import toggleMenu from "../../../redux/SideBar/sideBarActions";
import CommonIcon from "../../helpers/icons";
import { Offcanvas } from "react-bootstrap";
import {  Tooltip } from "@material-ui/core";
import {
  TextField,
  Avatar,
  Autocomplete,
  Paper,
  FormLabel,
  Switch,
  Button,
  TextareaAutosize,
  skeletonClasses,
} from "@mui/material";
import EditTeamsPage from "./editteams";
import Action from "../../../action/api";
import API from "../../helpers/endpointservice";
import CircularProgress from "@mui/material/CircularProgress";
import { toast, ToastContainer } from "react-toastify";
import Backdrop from "@mui/material/Backdrop";

const Teamspage = () => {
  let initialAdd = {
    teamName: "",
    teamDescription: "",
    ownerId: "",
  };

  let initialError = {
    name: false,
    owner: false,
  };

  const [teamsData, setTeamsData] = useState([]);
  const [teamAdd, setTeamAdd] = useState(initialAdd);
  const [teamError, setTeamError] = useState(initialError);
  const [isMobile, setIsMobile] = useState(false);
  const [isWebMobile, setIsWebMobile] = useState(false);
  const [addTeamsOffcanvas, setAddTeamsOffcanvas] = useState(false);
  const [editTeamsOffcanvas, setEditTeamsOffcanvas] = useState(false);
  const [currentEdit, setCurrentEdit] = useState({});
  const [filterScreen, setFilterScreen] = useState(false);
  const [loader, setloader] = useState(false);
  const [activeUsers, setActiveUsers] = useState([]);
  const [filterValue, setFilterValue] = useState("");
  const [isFilterApplied, setFilterApplied] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    getTeamsData("");
    getActiveUser();
  }, []);

  const getTeamsData = (name) => {
    setloader(true);
    Action.GET(`${API.Teams}/All${name ? `?TeamName=${name.trim()}` : ""}`)
      .then((res) => {
        if (res.data.data) {
          setTeamsData(res.data.data);
          setFilterScreen(false);
        }
        if (name.trim() == "") {
          setFilterApplied(false);
        } else {
          setFilterApplied(true);
        }
        setloader(false);
      })
      .catch((error) => {
        console.log(error);
        setloader(false);
      });
  };

  const getActiveUser = () => {
    Action.GET(`${API.Teams}/ActiveUsers`)
      .then((res) => {
        if (res.data) {
          setActiveUsers(res.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const ApplyFilter = () => {
    let name = filterValue;
    if (name.trim() !== "") {
      getTeamsData(name);
    }
    else{
        customToast("Please provide filter value")
    }
  };

  const ResetFilter = () => {
    setFilterValue("");
    getTeamsData("");
  };

  const handleTeamChane = (type, value) => {
    setTeamAdd((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const handleErrorChange = (type, value) => {
    setTeamError((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const handleValidation = () => {
    let error = false;
    if (teamAdd.teamName.trim() == "") {
      error = true;
      handleErrorChange("name", true);
    } else {
      handleErrorChange("name", false);
    }

    if (teamAdd.ownerId.trim() == "") {
      error = true;
      handleErrorChange("owner", true);
    } else {
      handleErrorChange("owner", false);
    }

    return error;
  };

  const handleTeamAdd = () => {
    if (!handleValidation()) {
      let data = {
        ...teamAdd,
      };
      setloader(true);
      Action.POST(API.Teams, data)
        .then((res) => {
          console.log(teamAdd);
          setTeamAdd(initialAdd);
          setAddTeamsOffcanvas(false);
          getTeamsData("");
        })
        .catch((error) => {
          console.log(error);
          if (
            error?.response?.data?.message?.trim() ==
            "Team is already exists in this tenant"
          ) {
            customToast("Team already exists.");
          }
          setloader(false);
        });
    }
  };

  const customToast = (message) => {
    toast(message, {
      hideProgressBar: true,
      autoClose: 2000, // Customize time as per your requirement
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      position: "top-right",
      className: "custom-toast", // Add a custom class here
    });
  };

  const resize = () => {
    if (window.innerWidth < 468) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }

    if (window.innerWidth < 800) {
      setIsWebMobile(true);
    } else {
      setIsWebMobile(false);
    }
  };

  useEffect(() => {
    resize();
    window.addEventListener("resize", resize);

    return () => {
      window.removeEventListener("resize", resize);
    };
  }, []);

  const editTeams = (data) => {
    setCurrentEdit(data);
    setEditTeamsOffcanvas(true);
  };

  const closeTeamAdd = () => {
    setAddTeamsOffcanvas(false);
    setTeamError(initialError);
    setTeamAdd(initialAdd);
  };

  return (
    <>
      <ToastContainer position="top-right" />
      <Backdrop className="spinner-backdrop" open={loader}>
        <CircularProgress color="primary" />
      </Backdrop>
      {
        !isMobile && (
          <div className="row ps-1 pe-4 d-flex justify-content-between">
            <div className="col-lg-5 col-sm-6 col-md-6 col-6">
              <span className="headerform1 ">Teams</span>
            </div>
            <div className="col-lg-7 col-md-6 col-sm-6 d-flex justify-content-end pe-2">
              <button
                className=" btn-fun btn-new fs-7"
                type="button"
                onClick={() => {
                  setAddTeamsOffcanvas(true);
                }}
              >
                <CommonIcon fileName={"AddPlus"} />
                Add Team
              </button>{" "}
              <button
                className=" btn-fun fs-7 ps-3 pe-3"
                type="button"
                onClick={() => {
                  setFilterScreen(true);
                }}
              >
                <CommonIcon
                  fileName={isFilterApplied ? "Filtered" : "Filter"}
                />
              </button>{" "}
            </div>
          </div>
        )
        // <div className="row ps-1 pe-4 d-flex justify-content-between">
        //     <div className="col-5 col-lg-5 col-sm-6 col-md-6">
        //         <span className="headerform ">Teams</span>
        //     </div>
        //     <div className="col-lg-7 col-sm-6 col-md-6 col-lg-6 d-flex justify-content-end pt-1 px-0">
        //             <button className=' btn-fun btn-new fs-7' type="button" onClick={() => { setAddTeamsOffcanvas(true) }} ><CommonIcon fileName={'AddPlus'} />Add Team</button>{' '}
        //             <button className=' btn-fun fs-7 ps-3 pe-3' type="button" ><CommonIcon fileName={'Filter'} /></button>{' '}

        //     </div>
        // </div>
      }

      {isMobile && (
        <div className="mobilemain mb-2">
          <div className="row px-2 pe-3">
            <div className="col-2 pe-1">
              <span
                className="mobile-menu"
                onClick={() => {
                  dispatch(toggleMenu());
                }}
              >
                <CommonIcon fileName={"Menu"} />
              </span>
            </div>
            <div className="col-4 ps-0">
              <span className="headerform-mobile">Teams</span>
            </div>
            <div className="col-6 pt-1 float-end pe-4">
              <div className="float-end d-flex">
                <button
                  className=" btn-fun btn-new fs-7"
                  type="button"
                  onClick={() => {
                    setAddTeamsOffcanvas(true);
                  }}
                >
                  <CommonIcon fileName={"AddPlus"} />
                  Add
                </button>{" "}
                <button
                  className=" btn-fun fs-7 ps-3 pe-3 me-0"
                  type="button"
                  onClick={() => {
                    setFilterScreen(true);
                  }}
                >
                  <CommonIcon
                    fileName={isFilterApplied ? "Filtered" : "Filter"}
                  />
                </button>{" "}
              </div>
            </div>
          </div>
        </div>
      )}

      { isFilterApplied && (
        <>
          <div className="pe-1 mt-0 mb-1">
            <span className={"filteredBadge"}>
              <span>Team Name</span>
              <span className="ms-2 cursor-pointer" onClick={ResetFilter}>
                <CommonIcon fileName={"CloseSmallwhite"} />
              </span>
            </span>
          </div>
          <p className="mb-0 mt-2 countValue">Count: {teamsData.length}</p>
        </>
      )}

      <div
        className={` ${isMobile ? "groupcardmobileteam" : "groupcard"}`}
        style={{ marginRight: "28px" }}
      >
        {teamsData.length > 0 ? (
          teamsData.map((element, index) => (
            <div className="s-1">
              <div
                className="card sharpcornerteams cursor-pointer  mt-2 "
                onClick={() => {
                  editTeams(element);
                }}
              >
                <div className="card-body">
                  <div
                    style={{
                      position: "absolute",
                      left: "0",
                      top: "-0.1px",
                      bottom: "-0.2px",
                      width: "4px",
                      backgroundColor: " rgb(33, 150, 243)",
                    }}
                  ></div>
                  <div className="row p-0 m-0 g-0 gap-0">
                    <div className="col-lg-2 col-md-12 col-sm-12 d-flex align-items-center pe-sm-2 pe-0 ">
                      <div className="row">
                        <div className="col-12">
                           <Tooltip title={element.teamName}>
                          <span
                            className="reporttext14 three-line-ellipsis"
                            style={{ fontWeight: "bold" }}
                          >
                            {element.teamName}
                          </span>
                          </Tooltip>
                        </div>
                        {/* <div className="col-12"><span className="reporttext12" style={{ fontWeight: "bold" }}>{}</span></div> */}
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-6 col-6 d-flex align-items-center">
                      <div className="row g-0 w-100">
                        <div className="col-lg-6 col-md-6 col-sm-12 mt-md-0 mt-2">
                          <div className="row ">
                            <div className="col-12">
                              <span className="reporttext14">Owner</span>
                            </div>
                            <div className="col-12">
                              <span className="reporttext12">
                                {element.ownerName}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 mt-md-0 mt-2">
                          <div className="row ">
                            <div className="col-12">
                              <span className="reporttext14">
                                Total Members
                              </span>
                            </div>
                            <div className="col-12">
                              <span className="reporttext12">
                                {element.totalMembers}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-lg-2 col-md-2 col-12 d-flex align-items-center">
                                <div className="row ">
                                    <div className="col-12"><span className="reporttext14" >Owner</span></div>
                                    <div className="col-12"><span className="reporttext12" >{element.ownerName}</span></div>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-2 col-12 d-flex align-items-center">
                                <div className="row ">
                                    <div className="col-12"><span className="reporttext14" >Total Members</span></div>
                                    <div className="col-12"><span className="reporttext12" >{element.totalMembers}</span></div>
                                </div>
                            </div> */}
                    <div className="col-lg-4 col-md-6 col-sm-6 col-6 d-flex align-items-center">
                      <div className="row desc">
                        <div className="col-12">
                          <span className="reporttext14">Description</span>
                        </div>
                        <div className="col-12">
                          <span className="reporttext12desc">
                            {" "}
                            {element.description &&
                            element.description.length > 70
                              ? `${element.description.substring(0, 70)}...`
                              : element.description || "-"}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-2 col-md-0 col-sm-0 col-0 d-flex align-items-center justify-content-end d-none d-md-flex">
                      <div className="row ">
                        <CommonIcon
                          className="float-end"
                          fileName={"Arrownext"}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : !loader ? (
          <div className="s-1 pe-4">
            <div className="card sharpcornerteams  cursor-pointer px-2 my-2 mt-2 p-2">
              <div className="card-body">
                <div
                  style={{
                    position: "absolute",
                    left: "0",
                    top: "-0.1px",
                    bottom: "-0.2px",
                    width: "4px",
                    backgroundColor: " rgb(33, 150, 243)",
                  }}
                ></div>
                <div className="row">
                  <div className="col-12  d-flex align-items-center">
                    <div className="row text-center w-100">
                      <div className="col-12">
                        <span
                          className="nofound "
                          style={{ fontWeight: "bold" }}
                        >
                          No teams found
                        </span>
                      </div>
                      {/* <div className="col-12"><span className="reporttext12" style={{ fontWeight: "bold" }}>{}</span></div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>

      <Offcanvas
        show={addTeamsOffcanvas}
        placement="end"
        scroll={false}
        backdrop={true}
        id="AddGroup"
        onHide={() => {
          closeTeamAdd();
        }}
      >
        <div className={`offcanvas-header px-4  pt-2 pb-3 mt-10`}>
          <span className="headername1team">Add Team</span>
          <button
            data-bs-dismiss="offcanvas"
            className="offcavasclose p-0"
            onClick={() => closeTeamAdd()}
          >
            <CommonIcon fileName={"Close"} />
          </button>
        </div>
        <div
          className="offcanvas-body px-4 pt-0"
          style={{ overflow: "hidden" }}
        >
          <div className="row p-0 m-0">
            <div className="col-12 p-0">
              <FormLabel
                className="formlabel-style w-100"
                id="first-name-label"
              >
                Team Name<span className={`isrequired`}>*</span>
              </FormLabel>
              <TextField
                value={teamAdd.teamName}
                error={teamError.name}
                inputProps={{ maxLength: 255 }}
                helperText={teamError.name ? "Team name is missing" : ""}
                onChange={(e) => {
                  handleTeamChane("teamName", e.target.value);
                }}
                id="email"
                className={`filter_input br-4 }`}
                variant="filled"
                fullWidth
              />
            </div>
            <div className={`col-12 mt-3 p-0`}>
              <FormLabel
                className="formlabel-style w-100"
                id="first-name-label"
              >
                Owner<span className={`isrequired`}>*</span>
              </FormLabel>
              <Autocomplete
                error={teamError.owner}
                className="OwnerSelect"
                options={activeUsers}
                value={
                  activeUsers.find((user) => user.userId === teamAdd.ownerId) ||
                  null
                }
                onChange={(e, value) => {
                  handleTeamChane("ownerId", value?.userId);
                }}
                getOptionLabel={(option) => `${option.email}`}
                renderOption={(props, option) => (
                  <li
                    {...props}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontSize: "12px",
                    }}
                  >
                    <Avatar sx={{ width: 35, height: 35, marginRight: 2 }}>
                      {option.userName.charAt(0)}
                    </Avatar>
                    <div>
                      <strong>{option.userName}</strong>
                      <div>{option.email}</div>
                    </div>
                  </li>
                )}
                renderInput={(params) => (
                  <div className="d-flex">
                    <TextField
                      error={teamError.owner}
                      helperText={
                        teamError.owner ? "Select owner for team" : ""
                      }
                      id="email"
                      className={`filter_input br-4 OwnerSelect`}
                      variant="filled"
                      fullWidth
                      focused
                      {...params}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: null, // Removes the dropdown arrow
                        sx: {
                          height: "max-content",
                          "& .MuiAutocomplete-popupIndicator": {
                            display: "none", // Ensure any popup indicator is hidden
                          },
                        },
                        inputProps: {
                          ...params.inputProps,
                          style: {
                            paddingTop: "10.5px",
                            paddingBottom: "10.5px",
                            display: "flex",
                          },
                        },
                      }}
                    />
                  </div>
                )}
                sx={{ width: "100%", marginRight: 2 }}
              />
            </div>
            <div className={`col-12 mt-3 p-0`}>
              <FormLabel
                className="formlabel-style w-100"
                id="first-name-label"
              >
                Description
              </FormLabel>
              <TextareaAutosize
                fullWidth
                value={teamAdd.teamDescription}
                onChange={(e) => {
                  handleTeamChane("teamDescription", e.target.value);
                }}
                id="descriptionteams"
                className={`filter_input br-4 }`}
                variant="filled"
                focused
                minRows={5}
                style={{ paddingLeft: "13px" }}
              />
            </div>
            <div className="row mt-2">
              <div className="col-12 p-0">
                {/* <button data-bs-dismiss="offcanvas" className={`btn-cancel btn-filter-action border-none ms-1`} variant="outlined" onClick={() => this.closeForm()}>Cancel</button> */}
                <button
                  onClick={() => {
                    handleTeamAdd();
                  }}
                  className={`btn-fun btn-action btn-filter-action`}
                  variant="primary"
                >
                  Add
                </button>
              </div>
            </div>
          </div>
        </div>
      </Offcanvas>

      <Offcanvas
        show={editTeamsOffcanvas}
        placement="end"
        scroll={false}
        backdrop={true}
        id="AddForm2"
        style={{
          width: "calc(100%)",
          height: "100vh",
        }}
        onHide={() => setEditTeamsOffcanvas(false)}
      >
        <EditTeamsPage
          teamsData={teamsData}
          closeEdit={() => {
            setEditTeamsOffcanvas(false);
            getTeamsData("");
          }}
          currentData1={currentEdit}
          isWebMobile={isWebMobile}
          activeUsers={activeUsers}
          getTeamsData={getTeamsData}
          setloader={setloader}
        />
      </Offcanvas>

      <Offcanvas
        show={filterScreen}
        placement="end"
        scroll={false}
        backdrop={false}
        id="FilterScreen1"
        onHide={() => setFilterScreen(false)}
      >
        <div className={`offcanvas-header px-3 pt-4 pb-3 mt-10`}>
          <h6
            id="offcanvasRightLabel"
            className="modal-title head-span"
            style={{ fontWeight: "600" }}
          >
            Filter
          </h6>
          <button
            className="offcavasclose"
            onClick={() => {
              setFilterScreen(false);
            }}
          >
            <CommonIcon fileName={"Close"} />
          </button>
        </div>

        <div className="offcanvas-body ps-4 pt-0">
          <div className="row">
            <div
              className="row px-2"
              style={{ padding: "0px", paddingTop: "0" }}
            >
              <div className={`col-12 pe-0 mt-2`}>
                <TextField
                  id="jobOpTitle"
                  className="filter_input"
                  fullWidth
                  label="Team Name"
                  variant="filled"
                  value={filterValue}
                  onChange={(e) => {
                    setFilterValue(e.target.value);
                  }}
                  focused
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row pe-3">
          <div className="col-12 align_justify_end pb-20">
            <Button
              className="btn-clear mr-10 border-none"
              variant="outlined"
              // onClick={() => this.clearFilter()}
              sx={{
                textTransform: "none !important",
                borderRadius: 0, // Set borderRadius to 0 for sharp edges
                "&:hover": {
                  borderRadius: 0, // Ensure sharp edges on hover as well
                },
              }}
              onClick={() => {
                ResetFilter();
              }}
            >
              Reset
            </Button>
            <button
              className="btn-apply"
              variant="primary"
              onClick={() => {
                ApplyFilter();
              }}
            >
              Apply
            </button>
          </div>
        </div>
      </Offcanvas>
    </>
  );
};

export default Teamspage;
